<template>
  <v-container grid-list-md page>
    <v-flex>
      <h1 class="title primary--text my-3">おすすめのプレイリスト</h1>
      <div class="mt-5">
        <h2 class="title mb-4">おすすめの進行プレイリスト</h2>
        <v-layout row wrap>
          <v-flex xs12 sm6 lg4 v-for="item in recommended_listA" :key="item.playlist_id" class="hover-type01">
            <v-card :class="[item.background_color]" class="white--text">
              <v-container fluid grid-list-lg @click="moveDetail(item.playlist_id)">
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="subheading mb-2">{{ item.name }}</div>
                    </div>
                  </v-flex>
                  <v-flex xs5>
                    <v-card-media v-if="item.main_large_image != null"
                      :src="item.main_large_image"
                      height="125px"
                      contain
                    ></v-card-media>
                    <v-card-media v-else
                      height="125px"
                      contain
                    ></v-card-media>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </div>

      <v-divider class="my-3"></v-divider>

      <div class="mt-5">
        <h2 class="title mb-4">おすすめの歓談プレイリスト</h2>
        <v-layout row wrap>
          <v-flex xs12 sm6 lg4 v-for="item in recommended_listB" :key="item.playlist_id" class="hover-type01">
            <v-card :class="[item.background_color]" class="white--text">
              <v-container fluid grid-list-lg @click="moveDetail(item.playlist_id)">
                <v-layout row>
                  <v-flex xs7>
                    <div>
                      <div class="subheading mb-2">{{ item.name }}</div>
                    </div>
                  </v-flex>
                  <v-flex xs5>
                    <v-card-media v-if="item.main_large_image != null"
                      :src="item.main_large_image"
                      height="125px"
                      contain
                    ></v-card-media>
                    <v-card-media v-else
                      height="125px"
                      contain
                    ></v-card-media>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
  </v-container>
</template>

<script>
import PlayListService from '@/components/services/PlayListService.vue'
export default {
  name: 'Recommended',
  data () {
    return {
      recommended_listA: [],
      recommended_listB: []
    }
  },
  created () {
    this.getRecommendPrayListSet(1)
    this.getRecommendPrayListSet(2)
  },
  methods: {
    /**
     * タイプＩＤを使用してお勧めのプレイリストを取得
     **/
    getRecommendPrayListSet (typeId) {
      const transactionid = this.$store.state.transactionId
      PlayListService.findRecommendPlayListSet(typeId, transactionid, (response) => {
        switch (typeId) {
          case 1:
            this.recommended_listA = response
            break
          default:
            this.recommended_listB = response
        }
      }, (error) => {
        this.logging(error)
        return null
      })
    },
    moveDetail (playlistId) {
      this.logging('methods: moveDetail()')
      this.$router.push({path: '/home/recommended/detail/' + playlistId})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/recommended/Index.vue